module.exports = __webpack_public_path__ + "img/ASC_SORT.a5952868.svg";